export const AqiColorCodeString = (aqiValue: number) => {
  if (aqiValue <= 50 && aqiValue > 0) return "#00B050";
  else if (aqiValue > 50 && aqiValue <= 100) return "#92D050";
  else if (aqiValue > 100 && aqiValue <= 200) return "#FFFF00";
  else if (aqiValue > 200 && aqiValue <= 300) return "#FF9900";
  else if (aqiValue > 300 && aqiValue <= 400) return "#FF0000";
  else if (aqiValue > 400) return "#C00000";
  else return "#2bcd11";
};

export default function AQITable() {
  const data = [
    { range: "0-50", category: "Good", aqiValue: 50 },
    { range: "51-100", category: "Satisfactory", aqiValue: 100 },
    { range: "101-200", category: "Moderate", aqiValue: 200 },
    { range: "201-300", category: "Poor", aqiValue: 300 },
    { range: "301-400", category: "Very Poor", aqiValue: 400 },
    { range: "401-500", category: "Severe", aqiValue: 500 },
  ];

  return (
    <div className="max-w-md mx-auto mt-10 border border-gray-300 rounded-lg overflow-hidden shadow-md">
      <table className="w-full text-center">
        <thead>
          <tr className="bg-gray-800 text-white">
            <th className="py-2 px-4">AIR QUALITY INDEX (AQI)</th>
            <th className="py-2 px-4 border-l border-white">CATEGORY</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              className="even:bg-gray-100"
              style={{ backgroundColor: AqiColorCodeString(item.aqiValue) }}
            >
              <td className="py-2 px-4">{item.range}</td>
              <td className="py-2 px-4 border-l border-white">
                {item.category}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
